import { faker } from '@faker-js/faker'

import { getDescriptionTemplate } from './DescriptionTemplate'
import { getRequestOption } from './RequestOption'

import {
  ApprovalRequest,
  CreationRequest,
  ExtraCostStatus,
  ModificationRequest,
  TargetGender,
  TargetLanguage,
} from '../../contracts/service-offer'
import { ExtraPriceChargeType, ExtraPriceType } from '../../contracts/service-offer/AdminServiceOfferExtraPrice'
import { asBuilder } from '../asBuilder'

export const getApprovalRequest = asBuilder((): ApprovalRequest => {
  return {
    title: faker.string.uuid(),
    treatmentIds: faker.helpers.multiple(() => faker.number.int()),
    freeTags: faker.helpers.multiple(() => faker.string.uuid()),
    targetLanguage: faker.helpers.enumValue(TargetLanguage),
    targetGender: faker.helpers.enumValue(TargetGender),
    startsAtUtc: '2099-05-01T15:00:00.0000Z',
    endsAtUtc: '2099-06-01T15:00:00.0000Z',
    paymentEnabled: faker.datatype.boolean(),
    exclusivePrice: faker.datatype.boolean(),
    vat: faker.helpers.enumValue(ExtraCostStatus),
    extraPrices: faker.helpers.multiple(
      () => ({
        type: faker.helpers.enumValue(ExtraPriceType),
        chargeType: faker.helpers.enumValue(ExtraPriceChargeType),
        amount: faker.number.int({ min: 1, max: 1000000 }),
      }),
      {
        count: {
          min: 1,
          max: 10,
        },
      },
    ),
    options: faker.helpers.multiple(getRequestOption),
    thumbnail: { url: faker.image.url() },
    cardImage: { url: faker.image.url() },
    descriptionImages: {
      images: [{ url: faker.image.url() }, { url: faker.image.url() }],
    },
    description: faker.string.uuid(),
    descriptionTemplate: getDescriptionTemplate(),
  }
})

export const getCreationRequest = asBuilder((): CreationRequest => {
  return {
    groupId: faker.string.uuid(),
    ...getApprovalRequest(),
  }
})

export const getModificationRequest = asBuilder((): ModificationRequest => {
  return {
    serviceOfferId: faker.number.int(),
    ...getApprovalRequest(),
  }
})
